import { Options } from '../../Options'
import { ChartBarConstants } from './ChartBar.constants'

export const chartBarOptions = Options.asRecord(
  Options.createOption({
    key: 'barOrientation',
    inputKind: 'select',
    selectChoices: [
      { value: 'vertical', label: 'Vertical' },
      { value: 'horizontal', label: 'Horizontal' },
    ],
    defaultValue: ChartBarConstants.defaultBarOrientation,
    label: 'Bar orientation',
    description:
      'Category axis along X (vertical bars) or Y (horizontal bars).',
    category: 'Bar',
  }),
  Options.createOption({
    key: 'barLayout',
    inputKind: 'select',
    selectChoices: [
      { value: 'grouped', label: 'Grouped' },
      { value: 'stacked', label: 'Stacked' },
      { value: 'stacked100', label: 'Stacked 100%' },
    ],
    defaultValue: ChartBarConstants.defaultBarLayout,
    label: 'Bar layout',
    description:
      'Grouped (side-by-side), stacked (absolute), or stacked 100% (percent of category total).',
    category: 'Bar',
  }),
  Options.createOption({
    key: 'barSize',
    inputKind: 'number',
    min: 1,
    max: 80,
    step: 1,
    label: 'Bar size',
    description:
      'Bar thickness in pixels (width when vertical, height when horizontal). Omit for Figma defaults.',
    category: 'Bar',
  }),
  Options.createOption({
    key: 'barGap',
    inputKind: 'number',
    defaultValue: ChartBarConstants.defaultBarGap,
    min: 0,
    max: 40,
    step: 1,
    label: 'Bar gap',
    description: 'Pixels between grouped bars in the same category.',
    category: 'Bar',
  }),
  Options.createOption({
    key: 'barCornerRadius',
    inputKind: 'number',
    defaultValue: ChartBarConstants.defaultCornerRadius,
    min: 0,
    max: 16,
    step: 1,
    label: 'Bar corner radius',
    description: 'Corner radius in pixels. Figma NextGen bars are square (0).',
    category: 'Bar',
  }),
)

export type ChartBarOptions = Options.TypeOf<typeof chartBarOptions>
export type ChartBarOrientation = Options.ResolvedTypeOf<
  typeof chartBarOptions
>['barOrientation']
export type ChartBarLayout = Options.ResolvedTypeOf<
  typeof chartBarOptions
>['barLayout']
